var map = {
	"./bash": 1538,
	"./java": 1539,
	"./json": 1540,
	"./julia": 1541,
	"./python": 1542,
	"./r": 1543,
	"./rust": 1544,
	"./scala": 1545,
	"./shell": 1546,
	"./sql": 1547,
	"./xml": 1548,
	"./yaml": 1549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;